import { Component } from '@angular/core';

// Branded spinner shown while a screen's data loads (replaces the old plain
// "Loading…" text). Theme-aware via the portal CSS variables. Styles live
// globally in styles.scss.
@Component({
	selector: 'portal-loader',
	template: `
		<div class="portal-loader">
			<div class="portal-spinner" role="status" aria-label="Loading"></div>
		</div>
	`
})
export class LoaderComponent {}
